import script from "./resource-page.vue?vue&type=script&setup=true&lang=js"
export * from "./resource-page.vue?vue&type=script&setup=true&lang=js"

import "./resource-page.vue?vue&type=style&index=0&id=25a2c8ec&scoped=true&lang=scss"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a2c8ec"]])

export default __exports__